import React, { useContext, useState, useEffect } from "react";
import { Modal } from "reactstrap";
import { IoClose } from "react-icons/io5";
import Sub1Icon from "../../assets/images/Sub2.svg";
import { FiAlertCircle } from "react-icons/fi";
import { Language } from "../../App";
import { MdKeyboardArrowDown, MdKeyboardArrowUp } from "react-icons/md";
import { FaCheckCircle, FaTimes, FaTimesCircle } from "react-icons/fa";
import MixpanelManager from "../../constants/MixpanelManager";
import { MixpanelEvents } from "../../constants/MixpanelEvents";

function BenefitsDropdown({ isOpen }) {
  const { lang } = useContext(Language);
  const [open, setOpen] = useState(false);
  const [benefits, setBenefits] = useState([]);

  useEffect(() => {
    if (!isOpen) return;
    setBenefits([]);
    setOpen(false);
    try {
      const splash = JSON.parse(localStorage.getItem('SplashData'));
      const b =
        (Array.isArray(splash?.user?.active_subscription?.benefits) && splash.user.active_subscription.benefits.length > 0 && splash.user.active_subscription.benefits) ||
        (Array.isArray(splash?.benefits) && splash.benefits.length > 0 && splash.benefits) ||
        [];
      setBenefits(b);
    } catch { }
  }, [isOpen]);

  const formatKey = (key) => {
    const langKey = `benefit_${key}`;
    if (lang?.[langKey]) return lang[langKey];
    return key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
  };

  return (
    <div className="wsub-status-row" style={{ flexDirection: 'column', alignItems: 'stretch', padding: '9px 0 0' }}>
      <div
        style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', cursor: 'pointer', paddingBottom: open ? '8px' : '9px' }}
        onClick={() => {
  const newOpen = !open;
  if (newOpen) {
    MixpanelManager.track(MixpanelEvents.VIEW_BENEFITS, {
     
    });
  }
  setOpen(newOpen);
}}
//  user_id: JSON.parse(localStorage.getItem("SignupData"))?.data?.user_id || "",
      >
        <span className="wsub-status-row-label" style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
         {lang?.withsub_status_benefits || 'benefits'}
          {open ? <MdKeyboardArrowUp size={18} color="black" /> : <MdKeyboardArrowDown size={18} color="black" />}
        </span>
        <span className="wsub-badge-not-enabled">{lang?.withsub_status_not_enabled || 'Not enabled'}</span>
      </div>
      {open && (
        <div style={{ borderTop: '0.5px solid #E6E7EA', paddingTop: '8px', display: 'flex', flexDirection: 'column', gap: '6px' }}>
          {benefits.length === 0 ? (
            <p style={{ fontSize: '12px', color: '#848798', margin: 0, textAlign: 'center' }}>All benefits are Locked</p>
          ) : (
            benefits.map((b) => (
              <div key={b.id} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                <span style={{ fontSize: '13px', color: '#0f1419' }}>{formatKey(b.benefit_key)}</span>
                {b.is_enabled === true || b.is_enabled === 1
                  ? <FaCheckCircle size={15} color="#00BC7D" />
                  : <FaTimes size={15} style={{backgroundColor:"#FFE2E2", borderRadius:"50px", padding:"2px"}} color="#FF2D55" />}
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
}

export default function WithSub({ isOpen, onClose, featureName = "Ophthalmology Radar" }) {
  const { lang } = useContext(Language);
  return (
    <>
      <style>{`
        .wsub-modal .modal-dialog {
          max-width: 440px;
          margin: auto;
        }
        .wsub-modal .modal-content {
          border: none;
          border-radius: 10px;
          overflow: hidden;
          box-shadow: 0 20px 60px rgba(0,0,0,0.18);
        }

        /* ── Header ── */
        .wsub-header {
          background: linear-gradient(135deg, #1DC1DD 0%, #17a8c4 100%);
          padding: 36px 24px 28px;
          text-align: center;
          position: relative;
        }
        .wsub-close-btn {
          position: absolute;
          top: 14px;
          right: 14px;
          width: 30px;
          height: 30px;
          border-radius: 50%;
          background: rgba(255,255,255,0.22);
          border: none;
          cursor: pointer;
          display: flex;
          align-items: center;
          justify-content: center;
          color: #fff;
          font-size: 15px;
          font-weight: 700;
          transition: background 0.15s;
          padding: 0;
        }
        .wsub-close-btn:hover { background: rgba(255,255,255,0.35); }

        .wsub-icon-wrap {
          width: 100px;
          height: 100px;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 14px;
          position: relative;
        }

        .wsub-title {
          font-size: 20px;
          font-weight: 700;
          color: #fff;
          margin: 0 0 4px;
          letter-spacing: -0.01em;
        }
        .wsub-subtitle {
          font-size: 13px;
          color: rgba(255,255,255,0.82);
          margin: 0;
        }

        /* ── Body ── */
        .wsub-body {
          padding: 20px 22px 24px;
          background: #fff;
        }

        /* ── Alert banner ── */
        .wsub-alert {
          background: rgba(29, 193, 221, 0.1);
          border: 1px solid rgba(29, 193, 221, 0.2);
          border-radius: 12px;
          padding: 12px 14px;
          display: flex;
          gap: 10px;
          align-items: flex-start;
          margin-bottom: 18px;
        }
        .wsub-alert-icon {
          width: 28px;
          height: 28px;
          border-radius: 50%;
          background: rgba(29, 193, 221, 0.2);
          display: flex;
          align-items: center;
          justify-content: center;
          flex-shrink: 0;
          margin-top: 0.5px;
        }
        .wsub-alert-title {
          font-size: 15px;
          font-weight: 600;
          color: #1DC1DD;
          margin: 0 0 3px;
        }
        .wsub-alert-text {
          font-size: 12px;
          color: #848798;
          margin: 0;
          line-height: 1.5;
        }

        /* ── Status card ── */
        .wsub-status-card {
          background: #F8F9FA;
          border: 1px solid #ECECEC;
          border-radius: 14px;
          padding: 14px 16px;
          margin-bottom: 18px;
        }
        .wsub-status-label {
          font-size: 10px;
          font-weight: 600;
          letter-spacing: 0.08em;
          color: #848798;
          text-transform: uppercase;
          margin-bottom: 12px;
        }
        .wsub-status-row {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 9px 0;
        }
        .wsub-status-row + .wsub-status-row {
          border-top: 0.5px solid #E6E7EA;
        }
        .wsub-status-row-label {
          font-size: 14px;
          font-weight: 500;
          color: #0f1419;
        }
        .wsub-badge-active {
          font-size: 12px;
          background: rgba(0, 188, 125, 0.14);
          border-radius: 20px;
          padding: 3px 12px;
          color: #00BC7D;
          font-weight: 600;
          white-space: nowrap;
        }
        .wsub-badge-not-enabled {
          font-size: 12px;
          background: rgba(228, 120, 11, 0.14);
          border-radius: 20px;
          padding: 3px 12px;
          color: #E4780B;
          font-weight: 600;
          white-space: nowrap;
        }

        /* ── CTA button ── */
        .wsub-cta-btn {
          width: 100%;
          background: #1DC1DD;
          color: #fff;
          border: none;
          border-radius: 12px;
          padding: 13px;
          font-size: 15px;
          font-weight: 700;
          cursor: pointer;
          letter-spacing: 0.01em;
          transition: background 0.15s, transform 0.1s;
          margin-bottom: 8px;
          display: block;
        }
        .wsub-cta-btn:hover { background: #17a8c4; }
        .wsub-cta-btn:active { transform: scale(0.98); }

        .wsub-cta-note {
          font-size: 12px;
          color: #687684;
          text-align: center;
          margin: 0;
          line-height: 1.5;
        }

        /* ── Medium screens (481px – 768px) ── */
        @media (max-width: 768px) {
          .wsub-modal .modal-dialog {
            padding: 0 16px;
            margin: 20px auto;
          }
          .wsub-header {
            padding: 28px 20px 22px;
          }
          .wsub-icon-wrap {
            width: 85px;
            height: 85px;
          }
          .wsub-title {
            font-size: 18px;
          }
          .wsub-subtitle {
            font-size: 12px;
          }
          .wsub-body {
            padding: 16px 18px 20px;
          }
          .wsub-alert {
            padding: 10px 12px;
          }
          .wsub-alert-title {
            font-size: 14px;
          }
          .wsub-status-card {
            padding: 12px 14px;
          }
          .wsub-status-row-label {
            font-size: 13px;
          }
          .wsub-cta-btn {
            font-size: 14px;
            padding: 12px;
          }
        }

        /* ── Small screens (≤480px) ── */
        @media (max-width: 480px) {
          .wsub-modal .modal-dialog {
            padding: 0 10px;
            margin: 12px auto;
          }
          .wsub-header {
            padding: 22px 16px 18px;
          }
          .wsub-close-btn {
            top: 10px;
            right: 10px;
            width: 26px;
            height: 26px;
            font-size: 13px;
          }
          .wsub-icon-wrap {
            width: 70px;
            height: 70px;
            margin-bottom: 10px;
          }
          .wsub-title {
            font-size: 16px;
          }
          .wsub-subtitle {
            font-size: 11px;
          }
          .wsub-body {
            padding: 14px 14px 18px;
          }
          .wsub-alert {
            gap: 8px;
            padding: 10px 10px;
            margin-bottom: 14px;
          }
          .wsub-alert-icon {
            width: 24px;
            height: 24px;
          }
          .wsub-alert-title {
            font-size: 13px;
          }
          .wsub-alert-text {
            font-size: 11px;
          }
          .wsub-status-card {
            padding: 10px 12px;
            margin-bottom: 14px;
            border-radius: 10px;
          }
          .wsub-status-row {
            padding: 7px 0;
            gap: 8px;
          }
          .wsub-status-row-label {
            font-size: 12px;
          }
          .wsub-badge-active,
          .wsub-badge-not-enabled {
            font-size: 11px;
            padding: 2px 9px;
          }
          .wsub-cta-btn {
            font-size: 13px;
            padding: 11px;
            border-radius: 10px;
          }
          .wsub-cta-note {
            font-size: 11px;
          }
        }
      `}</style>

      <Modal
        isOpen={isOpen}
        toggle={onClose}
        centered
        backdrop="static"
        className="wsub-modal"
      >
        {/* ── HEADER ── */}
        <div className="wsub-header">
          <button className="wsub-close-btn" onClick={onClose} aria-label="Close">
            <IoClose />
          </button>

          <div className="wsub-icon-wrap">
            <img src={Sub1Icon} alt="subscription" style={{ width: "327px", height: "104px" }} />
          </div>

          <p className="wsub-title">{lang?.withsub_title || "Benefits Not Enabled"}</p>
          <p className="wsub-subtitle">
            {featureName}&nbsp;&nbsp;·&nbsp;&nbsp;{lang?.withsub_subtitle || "Access Required"}
          </p>
        </div>

        {/* ── BODY ── */}
        <div className="wsub-body">

          {/* Alert */}
          <div className="wsub-alert">
            <div className="wsub-alert-icon">
              <FiAlertCircle size={16} color="#1DC1DD" style={{ marginLeft: "0.77px" }} />
            </div>
            <div>
              <p className="wsub-alert-title">{lang?.withsub_alert_title || "Action Required"}</p>
              <p className="wsub-alert-text">
                {lang?.withsub_alert_text || `Your subscription is active, but ${featureName} benefits are not enabled for your account. Contact support to request access.`}
              </p>
            </div>
          </div>

          {/* Account Status */}
          <div className="wsub-status-card">
            <p className="wsub-status-label">{lang?.withsub_status_label || "Account Status"}</p>

            <div className="wsub-status-row">
              <span className="wsub-status-row-label">{lang?.withsub_status_subscription || "Subscription"}</span>
              <span className="wsub-badge-active">{lang?.withsub_status_active || "Active"}</span>
            </div>

            <BenefitsDropdown isOpen={isOpen} />
          </div>

          {/* CTA */}
          <a
            href="https://mail.google.com/mail/?view=cm&fs=1&to=support@ophthalmologyradar.com&su=Benefit%20Request%20%E2%80%93%20Ophthalmology%20Radar"
            target="_blank"
            rel="noopener noreferrer"
            className="wsub-cta-btn"
            style={{ textDecoration: "none", textAlign: "center" }}
          >
            {lang?.withsub_cta_btn || "Contact Support"}
          </a>

          <p className="wsub-cta-note">
            {lang?.withsub_cta_note || "You'll be redirected to your email to send a benefit access request."}
          </p>
        </div>
      </Modal>
    </>
  );
}